import {Dictionary} from "../../../page/elements/dictionary";
import {type Filters, SearchFacade} from "./searchFacade";
import {resolve} from "../../../container";
import {UnLitElement} from "../../../common/elements";
import {customElement, property, state} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {trackingButtonInteract} from "../../../tracking/trackingAttributes";
import type {Nullable} from "../../../bootstrap/common/types";

@customElement("eop-search-filter-tags")
export class EopSearchFilterTags extends UnLitElement {

    @state()
    private appliedFilters: Filters;

    private dictionary: Dictionary;

    public constructor(private searchFacade: SearchFacade = resolve(SearchFacade)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();
        this.dictionary = Dictionary.of(this);

        this.searchFacade.onChangeGroup(() => this.updateTags());
        this.searchFacade.onAppliedFilter(() => this.updateTags());
        this.updateTags();
    }

    public render(): Nullable<TemplateResult> {
        if (this.appliedFilters.size === 0) {
            return null;
        }

        return html`
            ${this.dictionary.translate("CONTENT_SEARCH_RESULTS_FILTERS") + " "}
            ${this.renderAppliedFilterBlocks()}
        `;
    }

    private renderAppliedFilterBlocks(): TemplateResult[] {
        return Array.from(this.appliedFilters.entries())
            .flatMap(([category, values]) => html`
                <div class="applied-filter-block">
                    ${this.renderFilterTags(category, values)}
                </div>
            `);
    }

    private renderFilterTags(category: string, values: string[]): TemplateResult[] {
        return values.map(value => html`
            <eop-search-filter-tag .category=${category} .value=${value}></eop-search-filter-tag>`);
    }

    private updateTags(): void {
        this.appliedFilters = this.searchFacade.appliedFilters();
    }
}

@customElement("eop-search-filter-tag")
export class EopSearchFilterTag extends UnLitElement {

    @property({attribute: "category"})
    public category: string;
    @property({attribute: "value"})
    public value: string;

    public constructor(private searchFacade: SearchFacade = resolve(SearchFacade)) {
        super();
    }

    public render(): TemplateResult {
        const label = "disable filter: " + this.value;
        return html`
            <button type="button" class="reverse-background"
                    aria-label=${label}
                    @click=${this.removeFilter}
                    ${trackingButtonInteract(label)}
            >${this.value}</button>
        `;
    }

    private removeFilter(): void {
        void this.searchFacade.removeFilter(this.category, this.value);
    }
}
